import { defineComponent as _defineComponent } from 'vue'
import { renderMarkdown } from '~/functions/markdown'

export default /*#__PURE__*/_defineComponent({
  __name: 'OnlyLastQuarterFilled',
  setup(__props) {


return { __sfc: true,renderMarkdown }
}

})